<app-side-drawer-container>
  <glxy-page>
    <glxy-page-toolbar>
      <glxy-page-title>
        {{ 'USERS.BULK_IMPORT.IMPORT_WIZARD' | translate }}
      </glxy-page-title>
      <glxy-page-nav>
        <glxy-page-nav-button
          [previousPageTitle]="'LISTS.TITLE' | translate"
          [previousPageUrl]="'/action-lists/manage'"
          [useHistory]="true"
          [historyBackButtonTitle]="'COMMON.ACTION_LABELS.BACK' | translate"
        ></glxy-page-nav-button>
      </glxy-page-nav>
    </glxy-page-toolbar>
    <glxy-page-wrapper [widthPreset]="'wide'">
      <mat-vertical-stepper #stepper class="stepper mat-elevation-z0" [linear]="true">
        <mat-step [stepControl]="fileForm">
          <form [formGroup]="fileForm">
            <ng-template matStepLabel>
              {{ 'USERS.BULK_IMPORT.UPLOAD_CSV_OF_ACCOUNTS' | translate }}
            </ng-template>
            <div>
              {{ 'USERS.BULK_IMPORT.UPLOAD_EXISTING_CUSTOMER_DATA' | translate }}
            </div>
            <div>
              {{ 'USERS.BULK_IMPORT.ADD_UP_TO_15_COLUMNS' | translate }}
            </div>
            <div style="margin-top: 16px">
              {{ 'USERS.BULK_IMPORT.REQUIRED_FIELDS' | translate }}
              <strong>CompanyName</strong>
              {{ 'STORE.AND' | translate }}
              <strong>Zip</strong>
              .
              <div class="maxSizeWarning">
                {{ 'USERS.BULK_IMPORT.MAXIMUM_FILE_SIZE' | translate }}
                <strong>4MB</strong>
                .
              </div>
            </div>
            <div style="width: 400px">
              <mat-icon matSuffix class="attach-file-icon">attach_file</mat-icon>
              <input
                type="file"
                #removableInput
                formControlName="file"
                [accept]="fileTypes.join(', ')"
                placeholder="Select file..."
                (change)="fileOnChange($event)"
                required
                data-testid="import-file-input"
                data-action="clicked-upload-file-bulk-import"
                />
              @if (!removableInput.empty) {
                <button
                  mat-icon-button
                  matSuffix
                  (click)="clearInput($event, removableInput)"
                  >
                  <mat-icon>clear</mat-icon>
                </button>
              }
              @if (fileFormControl.hasError('required')) {
                <mat-error>
                  {{ 'COMMON.THIS_FIELD_REQUIRED' | translate }}
                </mat-error>
              }
            </div>
            @if (processing) {
              <mat-spinner class="processing-spinner inline" [diameter]="30"></mat-spinner>
            }
            @if (processingErrorMessage) {
              <mat-error
                class="error"
                innerHTML="{{ processingErrorMessage }}"
              ></mat-error>
            }
            <div style="margin-top: 16px">
              {{ 'USERS.BULK_IMPORT.AVAILABLE_FILES' | translate }}
            </div>
            <div>
              <div>
                <a (click)="downloadTemplate()" target="_blank">
                  <mat-icon color="primary">save_alt</mat-icon>
                  <span class="downloadLink">
                    {{ 'USERS.BULK_IMPORT.DOWNLOAD_CSV_TEMPLATE' | translate }}
                  </span>
                </a>
              </div>
              <div>
                <a (click)="downloadBusinessCategories()" target="_blank">
                  <mat-icon color="primary">save_alt</mat-icon>
                  <span class="downloadLink">
                    {{ 'USERS.BULK_IMPORT.DOWNLOAD_BUSINESS_CATEGORIES' | translate }}
                  </span>
                </a>
              </div>
            </div>

            <div>
              <button
                class="nextBtn"
                mat-flat-button
                color="primary"
                (click)="goToFieldMapping()"
                data-action="clicked-next-file-upload-bulk-import"
                >
                {{ 'COMMON.ACTION_LABELS.NEXT' | translate }}
              </button>
            </div>
          </form>
        </mat-step>
        <mat-step [label]="'USERS.BULK_IMPORT.MAP_FIELDS' | translate">
          <div style="margin-bottom: 32px">
            <glxy-alert type="info">
              <span [innerHtml]="'USERS.BULK_IMPORT.CONFIRM_COLUMNS' | translate"></span>
              <span
                [innerHtml]="
                  'USERS.BULK_IMPORT.FIELDS_MUST_BE_SELECTED' | translate: { fieldOne: 'CompanyName', fieldTwo: 'Zip' }
                "
              ></span>
            </glxy-alert>
          </div>
          <app-bulk-import-mapper [pageStepper]="pageStepper"></app-bulk-import-mapper>
        </mat-step>
        <mat-step [label]="'USERS.BULK_IMPORT.SET_USER_PERMISSIONS' | translate">
          <div class="userSettings">
            <div class="checkboxColumn">
              <mat-checkbox color="primary" id="userPermissions" [(ngModel)]="permissionsFlag"></mat-checkbox>
            </div>
            <div class="infoColumn">
              <span>
                {{
                'USERS.BULK_IMPORT.ALLOW_ACCESS_TO_BUSINESS_APP'
                | translate: { businessAppName: partnerBusinessCenterName$ | async }
                }}
              </span>
              <div class="userSettingsSubText">
                {{ 'USERS.BULK_IMPORT.CONFIGURE_PERMISSIONS_FOR_EACH_USER' | translate }}
              </div>
            </div>
          </div>
          <div class="userSettings">
            <mat-checkbox color="primary" id="userNotifications" [(ngModel)]="notificationsFlag"></mat-checkbox>
            <div class="infoColumn">
              <span>
                {{ 'USERS.BULK_IMPORT.TURN_ON_ALL_NOTIFICATIONS' | translate }}
              </span>
              <div
                class="userSettingsSubText"
                [innerHtml]="'USERS.BULK_IMPORT.SETTING_APPLIES_TO_NEW_USERS' | translate"
              ></div>
            </div>
          </div>
          <div class="userSettings">
            <div class="checkboxColumn">
              <mat-checkbox color="primary" id="welcomeEmail" [(ngModel)]="welcomeEmailFlag"></mat-checkbox>
            </div>
            <div class="infoColumn">
              <span>
                {{ 'USERS.BULK_IMPORT.SEND_WELCOME_EMAIL' | translate }}

                @if (emailLanguage === englishSelection) {
                  <a (click)="openPreview()" style="margin-left: 10px">
                    {{ 'COMMON.ACTION_LABELS.PREVIEW' | translate }}
                  </a>
                }
              </span>
              @if (welcomeEmailFlag) {
                <div>
                  <form>
                    <div class="emailSubSection">
                      <mat-form-field>
                        <mat-label>
                          {{ 'USERS.BULK_IMPORT.DEFAULT_EMAIL_LANGUAGE' | translate }}
                        </mat-label>
                        <mat-select [(value)]="emailLanguage">
                          @for (language of emailLanguages; track language) {
                            <mat-option [value]="language.id">
                              {{ language.name }}
                            </mat-option>
                          }
                        </mat-select>
                        <mat-hint>
                          {{ 'USERS.BULK_IMPORT.WELCOME_EMAIL_LANGUAGE' | translate }}
                        </mat-hint>
                      </mat-form-field>
                    </div>
                    <div>
                      <mat-form-field class="welcomeMessageBox">
                        <mat-label>
                          {{ 'USERS.BULK_IMPORT.WELCOME_MESSAGE' | translate }}
                        </mat-label>
                        <textarea
                          name="welcomeMessage"
                          matInput
                          cdkTextareaAutosize
                          cdkAutosizeMinRows="2"
                          cdkAutosizeMaxRows="15"
                          [(ngModel)]="welcomeMessage"
                        ></textarea>
                      </mat-form-field>
                    </div>
                  </form>
                </div>
              }
            </div>
          </div>
          <div>
            <button
              mat-stroked-button
              color="secondary"
              matStepperPrevious
              data-action="clicked-back-user-notification-bulk-import"
              >
              {{ 'COMMON.ACTION_LABELS.BACK' | translate }}
            </button>
            <button
              class="nextBtn"
              mat-flat-button
              matStepperNext
              color="primary"
              data-action="clicked-next-user-notification-bulk-import"
              >
              {{ 'COMMON.ACTION_LABELS.NEXT' | translate }}
            </button>
          </div>
        </mat-step>
        <mat-step [stepControl]="marketListForm">
          <form [formGroup]="marketListForm">
            <ng-template matStepLabel>{{ marketAndListText }}</ng-template>
            @if (hasAccessToMarkets$ | async) {
              <div class="form-field">
                <div>
                  <span class="half-bold">
                    {{ 'USERS.BULK_IMPORT.SELECT_MARKET_FOR_IMPORT' | translate }}
                  </span>
                </div>
                <mat-form-field style="width: 400px">
                  <input
                    matInput
                    [placeholder]="'COMMON.MARKET' | translate"
                    [formControl]="marketUiFormControl"
                    [errorStateMatcher]="marketMatcher"
                    [matAutocomplete]="marketAutocomplete"
                    (input)="updateSearchTerm(marketSearchTerm$$, $event.target.value)"
                    required
                    />
                  <mat-autocomplete
                    [autoActiveFirstOption]="selectFirstMarket"
                    #marketAutocomplete="matAutocomplete"
                    [displayWith]="nameDisplayFn"
                    (optionSelected)="selectMarket($event)"
                    required
                    >
                    @for (market of filteredMarkets$ | async; track market) {
                      <mat-option [value]="market">
                        {{ market.name }}
                      </mat-option>
                    }
                  </mat-autocomplete>
                  <mat-icon iconPositionEnd class="dropdown-arrow">arrow_drop_down</mat-icon>
                  @if (marketUiFormControl.hasError('required')) {
                    <mat-error>
                      {{ 'USERS.BULK_IMPORT.MARKET_IS_REQUIRED' | translate }}
                    </mat-error>
                  }
                </mat-form-field>
              </div>
            }
            <div>
              <span class="half-bold">
                {{ 'USERS.BULK_IMPORT.USE_OR_CREATE_NEW_LIST' | translate }}
              </span>
            </div>
            <mat-radio-group formControlName="useExistingList">
              <mat-radio-button [value]="true" color="primary" (click)="selectExistingList()" style="margin-top: 24px">
                {{ 'USERS.BULK_IMPORT.SELECT_EXISTING_LIST' | translate }}
              </mat-radio-button>
              <div class="form-field tabbed-in">
                @if (marketListForm.controls['useExistingList'].value) {
                  <mat-form-field
                    class="new-list-input tabbed-in"
                    >
                    <input
                      type="text"
                      matInput
                      [placeholder]="'USERS.BULK_IMPORT.SEARCH_OR_SELECT_LIST' | translate"
                      [formControl]="listFormControl"
                      [matAutocomplete]="auto"
                      [errorStateMatcher]="listMatcher"
                      (input)="updateSearchTerm(listSearchTerm$$, $event.target.value)"
                      />
                    <mat-autocomplete
                      #auto="matAutocomplete"
                      [displayWith]="displayFn"
                      (optionSelected)="selectList($event)"
                      >
                      @for (list of filteredLists$ | async; track list) {
                        <mat-option [value]="list">
                          {{ list.name }}
                        </mat-option>
                      }
                    </mat-autocomplete>
                    <mat-icon iconPositionEnd class="dropdown-arrow">arrow_drop_down</mat-icon>
                    @if (listFormControl.hasError('required')) {
                      <mat-error>
                        {{ 'USERS.BULK_IMPORT.SELECT_OR_CREATE_LIST' | translate }}
                      </mat-error>
                    }
                  </mat-form-field>
                }
              </div>
              <mat-radio-button [value]="false" color="primary" (click)="createNewList()" style="margin-top: 16px">
                {{ 'USERS.BULK_IMPORT.CREATE_NEW_LIST' | translate }}
              </mat-radio-button>
              <div class="form-field tabbed-in">
                @if (!marketListForm.controls.useExistingList.value) {
                  <mat-form-field class="new-list-input tabbed-in">
                    <input matInput placeholder="List Name" formControlName="actionListName" required />
                    @if (marketListForm.controls['actionListName'].hasError('required')) {
                      <mat-error>
                        {{ 'USERS.BULK_IMPORT.SELECT_OR_CREATE_LIST' | translate }}
                      </mat-error>
                    }
                  </mat-form-field>
                }
              </div>
            </mat-radio-group>

            <div>
              <button
                mat-stroked-button
                color="secondary"
                matStepperPrevious
                data-action="clicked-back-choose-list-bulk-import"
                >
                {{ 'COMMON.ACTION_LABELS.BACK' | translate }}
              </button>
              <button
                class="nextBtn"
                mat-flat-button
                matStepperNext
                color="primary"
                (click)="goToFinalStep()"
                data-action="clicked-next-choose-list-bulk-import"
                >
                {{ 'COMMON.ACTION_LABELS.NEXT' | translate }}
              </button>
            </div>
          </form>
        </mat-step>
        <mat-step>
          <ng-template matStepLabel>
            {{ 'USERS.BULK_IMPORT.REVIEW_IMPORT' | translate }}
          </ng-template>
          <div class="confirm-details">
            <div
              class="space-above"
              [innerHtml]="
                'USERS.BULK_IMPORT.ADDING_NUM_BUSINESSES_FROM' | translate: { numBusinesses: (this.netRows$ | async) }
              "
            ></div>
            <div class="tabbed-in">
              <mat-icon>insert_drive_file</mat-icon>
              <span class="tabbed-in-list-name">{{ filename }}</span>
            </div>
            <div class="space-above" [innerHtml]="listText"></div>
            <div class="tabbed-in">
              {{ listName }}
            </div>
            @if (hasAccessToMarkets$ | async) {
              <div class="space-above">
                <div [innerHtml]="'USERS.BULK_IMPORT.IN_THE_MARKET_NAMED' | translate"></div>
                <div class="tabbed-in">
                  {{ marketName }}
                </div>
              </div>
            }
            <div class="space-above">
              <div>
                {{ 'USERS.BULK_IMPORT.HOW_TO_TREAT_EMPTY_CELLS' | translate }}
              </div>
              <div class="tabbed-in form-field">
                <mat-checkbox [(ngModel)]="overwriteBlank">
                  {{ 'USERS.BULK_IMPORT.ATTEMPT_TO_FILL_EMPTY_CELLS' | translate }}
                </mat-checkbox>
              </div>
            </div>
          </div>
          <div>
            <div style="display: flex">
              <button
                mat-stroked-button
                color="secondary"
                matStepperPrevious
                data-action="clicked-back-review-import-bulk-import"
                >
                {{ 'COMMON.ACTION_LABELS.BACK' | translate }}
              </button>
              <button
                mat-flat-button
                color="primary"
                type="submit"
                (click)="startListImport()"
                [disabled]="loading"
                data-action="clicked-finish-bulk-import"
                >
                @if (loading) {
                  <mat-spinner
                    class="processing-spinner"
                    [diameter]="30"
                    style="margin: 3.5px 0px"
                  ></mat-spinner>
                }
                @if (!loading) {
                  <span>
                    {{ 'COMMON.ACTION_LABELS.FINISH' | translate }}
                  </span>
                }
              </button>
            </div>
          </div>
        </mat-step>
      </mat-vertical-stepper>
    </glxy-page-wrapper>
  </glxy-page>

  <ng-template #customFieldEditor>
    <aux-app-auxiliary-data-panel
      [createNewField]="true"
      [objectType]="'business'"
      [showObjectTypeControl]="false"
    ></aux-app-auxiliary-data-panel>
  </ng-template>
</app-side-drawer-container>
